module.exports = __webpack_public_path__ + "img/home_scene.cb10b235.png";